import { render, staticRenderFns } from "./GridHeader.vue?vue&type=template&id=bc67e09c&scoped=true&"
import script from "./GridHeader.vue?vue&type=script&lang=js&"
export * from "./GridHeader.vue?vue&type=script&lang=js&"
import style0 from "./GridHeader.vue?vue&type=style&index=0&id=bc67e09c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc67e09c",
  null
  
)

export default component.exports